import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import appearenceService from "./appearanceService";

const initialState = {
  gettingAppearanceLoading: false,
  gettingAppearanceSuccess: false,
  gettingAppearanceError: false,
  gettingAppearance:"",
  gettingAppearanceErrorMsg: "",
};

// _______________________customization  getting response function and services calling
export const gettingSettingUpdataData = createAsyncThunk(
    'getSettingData/gettingSettingUpdataData',
    async (datasdss, thunkAPI) => {
      try {
        const response = await appearenceService.gettingSettingUpdataData(datasdss);
        return response;
      } catch (error) {
        // handle all error like with status code  404 or 500 or 300 , not under 200
        const errorMsg =
          (error.response && error.response.data && error.response.data.errorMsg) || error.errorMsg || error.toString();
        return thunkAPI.rejectWithValue(errorMsg);
      }
    }
  );
  
  export const getScreenPreviewSetting = createAsyncThunk(
    'getScreenPreview/getScreenPreviewSetting',
    async (datasdss, thunkAPI) => {
      try {
        const response = await appearenceService.getScreenPreviewSetting(datasdss);
        return response;
      } catch (error) {
        // handle all error like with status code  404 or 500 or 300 , not under 200
        const errorMsg =
          (error.response && error.response.data && error.response.data.errorMsg) || error.errorMsg || error.toString();
        return thunkAPI.rejectWithValue(errorMsg);
      }
    }
  );

export const gettingAppearanceSlice = createSlice({
  name: 'gettingAppearance',
  initialState,
  reducers: {
    resetGettingAppearance: (state) => {
      state.gettingAppearanceLoading = false;
      state.gettingAppearanceSuccess = false;
      state.gettingAppearanceError = false;
      state.gettingAppearanceErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(gettingSettingUpdataData.pending, (state) => {
        state.gettingAppearanceLoading = true;
      })
      .addCase(gettingSettingUpdataData.fulfilled, (state, action) => {
        state.gettingAppearanceLoading = false;
        state.gettingAppearanceSuccess = true;
        state.gettingAppearance = action.payload;
      })
      .addCase(gettingSettingUpdataData.rejected, (state, action) => {
        state.gettingAppearanceLoading = false;
        state.gettingAppearanceError = true;
        state.gettingAppearanceErrorMsg = action.payload; // error from catch will come here via action.payload and update linkErrorMsg
      })


      .addCase(getScreenPreviewSetting.pending, (state) => {
        state.gettingAppearanceLoading = true;
      })
      .addCase(getScreenPreviewSetting.fulfilled, (state, action) => {
        state.gettingAppearanceLoading = false;
        state.gettingAppearanceSuccess = true;
        state.gettingAppearance = action.payload;
      })
      .addCase(getScreenPreviewSetting.rejected, (state, action) => {
        state.gettingAppearanceLoading = false;
        state.gettingAppearanceError = true;
        state.gettingAppearanceErrorMsg = action.payload; // error from catch will come here via action.payload and update linkErrorMsg
      });
  },
});
export const { resetGettingAppearance } = gettingAppearanceSlice.actions;
export default gettingAppearanceSlice.reducer;